export enum SchemaType {
  FAQ = 'FAQ',
  Custom = 'Custom',
  HowTo = 'HowTo',
  RedesignedHowTo = 'RedesignedHowTo',
  AggregateRating = 'AggregateRating',
  WebPage = 'WebPage',
  Organization = 'Organization',
  Website = 'Website',
  Product = 'Product',
  Review = 'Review',
  Breadcrumb = 'Breadcrumb',
  Article = 'Article',
  ItemList = 'ItemList',
  VideoObject = 'VideoObject',
}

export type JSONLinkedDataProps = {
  type?: SchemaType;
  data: any;
};

export type BreadcrumbSchemaDataModel = {
  link: string;
  anchor: string;
  position: number;
};
